import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Button } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable.js';
import useObtenerMenuItems from '../../Components/Hooks/useObtenerMenuItems.js';
import useCreateMenuItem from '../../Components/Hooks/useCreateMenuItem.js';
import useUpdateMenuItem from '../../Components/Hooks/useUpdateMenuItem.js';
import useDeleteMenuItem from '../../Components/Hooks/useDeleteMenuItem.js';
import ModalCrearMenuItem from '../../Components/modals/ModalCrearMenuItem.js';
import ModalModificarMenuItem from '../../Components/modals/ModalModificarMenuItem.js';
import ModalLeerMenuItem from '../../Components/modals/ModalLeerMenuItem.js';

const MenuItems = () => {

    const [selectedMenuItem, setSelectedMenuItem] = useState(null);
    const [refresh, setRefresh] = useState(0);
    const { menuItems, loading, error } = useObtenerMenuItems(refresh);
    const [modalCrearOpen, setModalCrearOpen] = useState(false);
    const [modalModificarOpen, setModalModificarOpen] = useState(false);
    const [modalLeerOpen, setModalLeerOpen] = useState(false);
    const { createMenuItem, loading: createLoading, error: createError } = useCreateMenuItem();
    const { updateMenuItem, loading: updateLoading, error: updateError } = useUpdateMenuItem();
    const { deleteMenuItem, loading: deleteLoading, error: deleteError } = useDeleteMenuItem();

    useEffect(() => {
        document.title = "Items de Menú | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "ID",
                accessorKey: "id",
                enableColumnFilter: false,
            },
            {
                header: "Etiqueta",
                accessorKey: "label",
                enableColumnFilter: false,
            },
            {
                header: "Descripción",
                accessorKey: "description",
                enableColumnFilter: false,
            },
            {
                header: "Enlace",
                accessorKey: "link",
                enableColumnFilter: false,
            },
            {
                header: "ID Padre",
                accessorKey: "parent_id",
                enableColumnFilter: false,
            },
            {
                header: "Es Hijo",
                accessorKey: "is_child_item",
                enableColumnFilter: false,
                cell: ({ getValue }) => getValue() ? 'Sí' : 'No',
            },
        ],
        []
    );

    const handleCellClick = (cellInfo) => {
        setSelectedMenuItem(cellInfo.rowData);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Items de Menú</h5>
                                    <div className="d-flex align-items-center">
                                        <Button color="primary" className="me-2" onClick={() => setModalCrearOpen(true)} disabled={createLoading}>
                                            <i className="ri-add-line me-1"></i>Crear
                                        </Button>
                                        <Button color="info" className="me-2" onClick={() => { if (selectedMenuItem) setModalLeerOpen(true); }} disabled={!selectedMenuItem}>
                                            <i className="ri-eye-line me-1"></i>Ver
                                        </Button>
                                        <Button color="warning" className="me-2" onClick={() => { if (selectedMenuItem) setModalModificarOpen(true) }} disabled={!selectedMenuItem || updateLoading}>
                                            <i className="ri-edit-line me-1"></i>Modificar
                                        </Button>
                                        <Button color="danger" className="me-2" onClick={async () => {
                                            if (selectedMenuItem && window.confirm('¿Está seguro que desea eliminar este item de menú? Esta acción no se puede deshacer.')) {
                                                const result = await deleteMenuItem(selectedMenuItem.id);
                                                if (result) {
                                                    alert('Item de menú eliminado');
                                                    setRefresh(prev => prev + 1);
                                                } else {
                                                    alert('Error: No se pudo eliminar');
                                                }
                                            }
                                        }} disabled={!selectedMenuItem || deleteLoading}>
                                            <i className="ri-delete-bin-line me-1"></i>Eliminar
                                        </Button>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {error ? <div className="alert alert-danger">{error}</div> : loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={menuItems?.records || []}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={handleCellClick}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ModalCrearMenuItem
                isOpen={modalCrearOpen}
                toggle={() => setModalCrearOpen(false)}
                onSave={async (formData) => {
                    const result = await createMenuItem(formData);
                    if (result) {
                        alert('Item de menú creado exitosamente');
                        setModalCrearOpen(false);
                        setRefresh(prev => prev + 1);
                    } else {
                        alert('Error al crear item de menú: ' + createError);
                    }
                }}
            />
            <ModalModificarMenuItem
                isOpen={modalModificarOpen}
                toggle={() => setModalModificarOpen(false)}
                selectedMenuItem={selectedMenuItem}
                onSave={async (formData) => {
                    const result = await updateMenuItem(selectedMenuItem.id, formData);
                    if (result) {
                        alert('Item de menú actualizado exitosamente');
                        setModalModificarOpen(false);
                        setRefresh(prev => prev + 1);
                    } else {
                        alert('Error al actualizar item de menú: ' + updateError);
                    }
                }}
            />
            <ModalLeerMenuItem
                isOpen={modalLeerOpen}
                toggle={() => setModalLeerOpen(false)}
                selectedMenuItem={selectedMenuItem}
            />
        </React.Fragment>
    )
}

export default MenuItems;